import { Typography } from "@mui/material";
import { formatNumberOnly, getCurrencySymbol } from "Utils/CurrencyUtils";

type Props = {
  currencyCode: string;
  amount: number;
};

export const Amount = ({ currencyCode, amount }: Props) => {
  const currencySymbol = currencyCode ? getCurrencySymbol(currencyCode) : null;

  const formattedAmount = formatNumberOnly(amount, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return (
    <Typography
      variant="h1"
      fontWeight={800}
      fontSize="3.75rem"
      lineHeight={1.1}
      display="flex"
      gap={2}
      justifyContent="center"
      flexWrap="wrap"
    >
      <span>{formattedAmount}</span>
      <span>{currencySymbol}</span>
    </Typography>
  );
};
